import { createAction, createApiAction, createErrorAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const updateQuery = createAction(types.UPDATE_QUERY);
export const updateSort = createAction(types.UPDATE_SORT);
export const incrementPage = createAction(types.INCREMENT_PAGE);
export const resetPage = createAction(types.RESET_PAGE);
export const updateDateFacet = createAction(types.UPDATE_DATE_FACET);
export const updateFacetValue = createAction(types.UPDATE_FACET_VALUE);
export const fetchFacetRequest = createAction(types.FETCH_FACET.REQUEST);
export const fetchFacetSuccess = createAction(types.FETCH_FACET.SUCCESS);
export const fetchFacetFailure = createErrorAction(types.FETCH_FACET.FAILURE);
export const extendFacet = createAction(types.EXTEND_FACET);
export const searchRequest = createAction(types.SEARCH.REQUEST);
export const searchSuccess = createAction(types.SEARCH.SUCCESS);
export const searchFailure = createErrorAction(types.SEARCH.FAILURE);
export const getTeamList = createApiAction(
  types.TEAMLIST_GET,
  api.getTeams,
  { meta: { skipErrorPage: true } },
);
